import React from 'react';

export const GDPR: React.FC = () => {
  return (
    <div className="p-4">
      <h1>Rekisteri- ja tietosuojaseloste</h1>
      <h2>
        Tämä on Tampereen Urheilusukeltajat ry:n (Taursu) EU:n yleisen
        tietosuoja-asetuksen (GDPR) mukainen rekisteri- ja tietosuojaseloste.
        Laadittu 30.11.2022. Viimeisin muutos 15.02.2026.
      </h2>
      <ul style={{ listStyle: 'none', padding: '0' }}>
        <li style={{ margin: '12px 0' }}>
          <h3>Rekisterinpitäjä</h3>
          <span>Tampereen Urheilusukeltajat ry</span>
          <br />
          <span>Hyllilänkatu 1 B talli 26</span>
          <br />
          <span>33730 Tampere</span>
          <br />
          <br />
          <span>Yhdistysrekisteritunnus 111.943</span>
          <br />
          <span>Y-tunnus 0592819-0</span>
          <br />
          <a href="mailto:jasenasiat.taursu@gmail.com">
            jasenasiat.taursu@gmail.com
          </a>
        </li>
        <li style={{ padding: '12px 0' }}>
          <h3>Rekisteristä vastaava yhteyshenkilö</h3>
          <span>Akseli Kolari</span>
          <br />
          <a href="mailto:gdpr@tayttopaikka.fi">gdpr@tayttopaikka.fi</a>
        </li>
        <li style={{ padding: '12px 0' }}>
          <h3>Rekisterin nimi</h3>
          <span>Täyttöpaikka-sovelluksen käyttäjärekisteri</span>
        </li>
        <li style={{ padding: '12px 0' }}>
          <h3>Oikeusperuste ja henkilötietojen käsittelyn tarkoitus</h3>
          <p>
            EU:n yleisen tietosuoja-asetuksen mukainen oikeusperuste
            henkilötietojen käsittelylle on henkilön suostumus (dokumentoitu,
            vapaaehtoinen, yksilöity, tietoinen ja yksiselitteinen).
          </p>
          <p>
            Henkilötietojen käsittelyn tarkoitus on tallentaa yhdistyksen
            sukelluspullojen täyttöpaikalla tapahtuneet kaasujen täytöt
            Turvallisuus- ja kemikaaliviraston määräysten mukaisesti, sekä
            myöhempää mahdollista laskutusta varten.
          </p>
          <p>
            Tietoja ei käytetä automatisoituun päätöksentekoon tai
            profilointiin.
          </p>
        </li>
        <li style={{ padding: '12px 0' }}>
          <h3>Rekisterin tietosisältö</h3>
          <p>
            Rekisteriin tallennettavia tietoja ovat: henkilön nimi, yhteystiedot
            (sähköpostiosoite, puhelinnumero), henkilön palveluun lisäämät
            sukelluspullot, kaasuseoksen täyttöoikeus ja tehtyjen kaasuseoksien
            tiedot (aika, koostumus, hinta).
          </p>
          <p>
            Käyttäjän tietoja säilytetään rekisterissä niin pitkään, kun
            käyttäjä aktiivisesti käyttää palvelua (Täyttöpaikka). Käyttäjän
            tunnus palveluun voidaan arkistoida, kun käyttäjän viime
            aktiivisuudesta palvelussa on kulunut kolme vuotta. Arkistoitujen
            käyttäjien tiedot anonymisoidaan vuoden kuluessa, jos he eivät
            osoita halukkuuttaan jatkaa palvelun käyttäjänä. Käyttäjän
            jäsenyyden päätyttyä Tampereen Urheilusukeltajat ry:ssä käyttäjän
            pääsy palveluun poistetaan ja hänen tietonsa anonymisoidaan.
            Käyttäjä voi pyytää tunnustensa poistamista, jolloin säilytetyt
            henkilötiedot anonymisoidaan. Edellämainittuja tietoja kuitenkin
            voidaan säilyttää niin pitkään, kunnes käyttäjä on suorittanut
            viimeiset maksuvelvoitteensa sukellusseuralle tekemistään
            kaasutäytöistä.
          </p>
        </li>
        <li style={{ padding: '12px 0' }}>
          <h3>Säännönmukaiset tietolähteet</h3>
          <p>
            Rekisteriin tallennettavat tiedot saadaan asiakkaalta mm.
            www-lomakkeilla lähetetyistä viesteistä, sähköpostitse, puhelimitse,
            asiakastapaamisista ja muista tilanteista, joissa asiakas luovuttaa
            tietojaan.
          </p>
        </li>
        <li style={{ padding: '12px 0' }}>
          <h3>
            Tietojen säännönmukaiset luovutukset ja tietojen siirto EU:n tai
            ETA:n ulkopuolelle
          </h3>
          <p>
            Tietoja ei luovuteta säännönmukaisesti muille tahoille. Tietoja
            voidaan kuitenkin luovuttaa viranomaisille onnettomuustapauksissa
            tai viranomaisten niitä pyytäessä. Tietoja ei julkaista. Tietoja ei
            siirretä EU:n tai ETA:n ulkopuolelle.
          </p>
          <p>Palvelu käyttää seuraavia tietojenkäsittelijöitä:</p>
          <ul>
            <li>
              <strong>Fly.io</strong> - Palvelun hosting ja tietojen säilytys.
              Rekisterinpitäjä on solminut Fly.io:n kanssa
              tietojenkäsittelysopimuksen, joka täyttää GDPR:n vaatimukset.
              Palvelu sijaitsee Amsterdamissa (Alankomaat) ja kaikki tiedot
              säilytetään palvelimilla Amsterdamissa. Tietokannan varmuuskopiot
              säilytetään Suomessa.
            </li>
            <li>
              <strong>Scaleway</strong> - Sähköpostipalvelu. Scaleway on
              eurooppalainen palveluntarjoaja. Sähköpostit lähetetään heidän
              palvelinkeskuksestaan Ranskassa.
            </li>
          </ul>
        </li>
        <li style={{ padding: '12px 0' }}>
          <h3>Rekisterin suojauksen periaatteet</h3>
          <p>
            Rekisterin käsittelyssä noudatetaan huolellisuutta ja
            tietojärjestelmien avulla käsiteltävät tiedot suojataan
            asianmukaisesti. Kun rekisteritietoja säilytetään
            Internet-palvelimilla, niiden laitteiston fyysisestä ja
            digitaalisesta tietoturvasta huolehditaan asiaankuuluvasti.
            Rekisterinpitäjä huolehtii siitä, että tallennettuja tietoja sekä
            palvelimien käyttöoikeuksia ja muita henkilötietojen turvallisuuden
            kannalta kriittisiä tietoja käsitellään luottamuksellisesti ja vain
            niiden yhdistyksen toimihenkilöiden toimesta, joiden toimenkuvaan se
            kuuluu.
          </p>
        </li>
        <li style={{ padding: '12px 0' }}>
          <h3>Tarkastusoikeus ja oikeus vaatia tiedon korjaamista</h3>
          <p>
            Jokaisella rekisterissä olevalla henkilöllä on oikeus tarkastaa
            rekisteriin tallennetut tietonsa ja vaatia mahdollisen virheellisen
            tiedon korjaamista tai puutteellisen tiedon täydentämistä. Mikäli
            henkilö haluaa tarkistaa hänestä tallennetut tiedot tai vaatia
            niihin oikaisua, pyyntö tulee lähettää sähköisesti
            rekisterinpitäjälle. Rekisterinpitäjä voi pyytää tarvittaessa
            pyynnön esittäjää todistamaan henkilöllisyytensä. Rekisterinpitäjä
            vastaa asiakkaalle EU:n tietosuoja-asetuksessa säädetyssä ajassa,
            pääsääntöisesti kuukauden kuluessa.
          </p>
        </li>
        <li style={{ padding: '12px 0' }}>
          <h3>Muut henkilötietojen käsittelyyn liittyvät oikeudet</h3>
          <p>
            Rekisterissä olevalla henkilöllä on oikeus pyytää häntä koskevien
            henkilötietojen poistamiseen rekisteristä ("oikeus tullaContinuous
            unohdetuksi"). Niin ikään rekisteröidyillä on muut{' '}
            <a href="http://eur-lex.europa.eu/legal-content/FI/TXT/?uri=CELEX%3A32016R0679#d1e2144-1-1">
              EU:n yleisen tietosuoja-asetuksen
            </a>{' '}
            mukaiset oikeudet, kuten henkilötietojen käsittelyn rajoittaminen
            tietyissä tilanteissa ja oikeus siirtää tiedot järjestelmästä
            toiseen. Pyynnöt tulee lähettää sähköisesti rekisterinpitäjälle.
            Rekisterinpitäjä voi pyytää tarvittaessa pyynnön esittäjää
            todistamaan henkilöllisyytensä. Rekisterinpitäjä vastaa asiakkaalle
            EU:n tietosuoja-asetuksessa säädetyssä ajassa, pääsääntöisesti
            kuukauden kuluessa.
          </p>
        </li>
        <li style={{ padding: '12px 0' }}>
          <h3>Oikeus tehdä valitus valvontaviranomaiselle</h3>
          <p>
            Rekisterissä olevalla henkilöllä on oikeus tehdä valitus
            toimivaltaiselle valvontaviranomaiselle, jos henkilö katsoo, että
            häntä koskevien henkilötietojen käsittelyssä rikotaan EU:n yleistä
            tietosuoja-asetusta.
          </p>
          <p>
            Suomen toimivaltainen valvontaviranomainen on:
            <br />
            <strong>Tietosuojavaltuutetun toimisto</strong>
            <br />
            Käyntiosoite: Lintulahdenkuja 4, 00530 Helsinki
            <br />
            Postiosoite: PL 800, 00531 Helsinki
            <br />
            Puhelinvaihde: 029 566 6700
            <br />
            Sähköposti: <a href="mailto:tietosuoja@om.fi">tietosuoja@om.fi</a>
            <br />
            Verkkosivut:{' '}
            <a
              href="https://tietosuoja.fi"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://tietosuoja.fi
            </a>
          </p>
        </li>
      </ul>
    </div>
  );
};
